import store from '../../init/store.js'
import {setBattleValue, setCombatantValue, setMatchmakingValue} from '../../redux-actions/battle-actions.js'
import {getUpdatedBattleState} from '../lifecycle/start-turn-series.js'
import {getObjectKeyDiff, getObjectAdditions} from '../../helpers/get-object-key-diff.js'
import CombatantModel from '../models/CombatantModel.js'
import {handleNewRollout} from '../lifecycle/handle-new-rollout.js'
import makeId from '../../helpers/make-id.js'
import {hasLoggedRolloutById} from '../lifecycle/has-logged-rollout-by-id.js'
import {submitBattleOver} from '../lifecycle/submit-battle-over.js'
import {getCombatantIdFromSelectingString} from '../get-combatant-id-from-selecting-string.js'
import {masterSelectsActionForBot, masterSubmitsQueuedAction} from '../lifecycle/master-submits-actions.js'
import audioManager from '../../_audio/audio-manager.js'
import {masterChecksForAllClientsReady} from './firebase-start-battle'

export function initFirebaseBattleBindings() {
  if (!window.firebase) {
    console.warn('Firebase not defined');
    return
  }

  //Check our room to see which ID is the master. If that is me, do the inital kickoff stuff.
  let masterId;
  window.roomRef.child('masterCombatantId').once("value", function (snapshot) {
    masterId = snapshot.val();

    if (store.getState().battle.battlePlayerId[0] === masterId) {
      setBattleValue({
        isMultiplayerMasterClient: true
      });
      //Master does a clean init of server state
      window.roomRef.child('hasBattleStarted').set(false);
      window.roomRef.child('rollout').set(null);
      window.roomRef.child('selectingCombatant').set(null);
      window.roomRef.child('bots').set(null);
    }
  });

  //Set up ref to me
  let presenceRef = window.roomRef.child(`connections/${store.getState().battle.battlePlayerId[0]}`);

  // Bind listener to go OFFLINE when browser is closed.
  presenceRef.onDisconnect().set(null);


  //Set my connection presence to my local player ID on the server
  presenceRef.set({
    //Store something to hold presence in firebase
    isHere: true

  }).then(function() {

    //I am online!
    //console.log('I am set to online');

    //----------- SUBSCRIBING TO CHANGES---------------------------
    // Subscribe to changes on hasBattleStarted
    window.roomRef.child('hasBattleStarted').on("value", function (snapshot) {
      if (snapshot.val()) { //true or false
        setBattleValue({
          hasBattleStarted: true //Transitions me (the client) to arena mode (see render of OnlineLoginWall)
        });

        //If I had an editing window open, please close it!
        setMatchmakingValue({
          editingCombatantProperties: {isActivated: false}
        })
      }
    });

    //Subscribe to initialCombatantData so lobby knows who is here (and their current loadout)
    window.roomRef.child('initialCombatantData').on("value", function (snapshot) {
      setMatchmakingValue({
          initialCombatantData: snapshot.val()
        })
    });

    //Subscribe to crewNames so lobby knows when names are changed
    window.roomRef.child('crewNames').on("value", function (snapshot) {
      setMatchmakingValue({
        crewNames: snapshot.val()
      })
    });


    //Subscribe to crewNames so lobby knows when names are changed
    window.roomRef.child('readyClients').on("value", function (snapshot) {
      setMatchmakingValue({
        readyClients: snapshot.val() || {}
      });

      masterChecksForAllClientsReady();
    });

    //Subscribe to the taunt message
    window.roomRef.child('taunt').on("value", function (snapshot) {
      if (snapshot.val()) {

        //play the voice sfx
        audioManager.playSfx("sfx_taunt");

        //extract the text message
        const tauntModel = snapshot.val(); //{message, timstamp}

        //set text message to state
        setBattleValue({
          arenaTaunt: tauntModel.message
        });
        setTimeout(() => {
          setBattleValue({ arenaTaunt: null });
        }, 3000); //Clear it out in 3 seconds
        // (TODO: This will be problematic if multiple taunts are coming through. Another problem for another day)
      }
    });


    // Subscribe to changes on connections
    window.roomRef.child('connections').on("value", function (snapshot) {
      //console.log('handle new connections', snapshot.val() );
      const newConnections = snapshot.val();
      const oldConnections = store.getState().battle.serverRoomConnections;

      // console.log('here are the connections', newConnections)

      //Set local connections
      setBattleValue({
        serverRoomConnections: newConnections
      });

      //Lobby Leavers!
      //If battle has NOT STARTED YET, take note that somebody left
      if (!store.getState().battle.hasBattleStarted) {

        //Master
        if (Object.keys(newConnections).length < Object.keys(oldConnections).length) {

          const lobbyLeaverObject = getObjectKeyDiff(newConnections, oldConnections);

          //Master notices somebody left. Remove them from firebase!
          if (store.getState().battle.isMultiplayerMasterClient) {
            // console.log('MASTER says: somebody left the lobby!', newConnections);
            //We need to figure out who left, remove their initialCombatantData from Firebase,
            // then the `initialCombatantData` listener will fire again on all clients

            Object.keys(lobbyLeaverObject).forEach(key => {
              const lobbyLeaverRef = window.roomRef.child('initialCombatantData').child(key);
              lobbyLeaverRef.remove();

              //Also delete this person's Buddies.
              Object.keys(store.getState().matchmaking.initialCombatantData).forEach(id => {
                // console.log('id', id)
                const model = store.getState().matchmaking.initialCombatantData[id];
                if (model.isBuddy && model.belongsToClient === key) {
                  const lobbyLeaverBuddyRef = window.roomRef.child('initialCombatantData').child(id);
                  lobbyLeaverBuddyRef.remove();
                }
              });

            })



          }

          //When anybody leaves, non-masters check if the leaver was the master (NOTE: this block is only for the lobby)
          if (!store.getState().battle.isMultiplayerMasterClient) {
            //If that leaver was the Master, create a new master!
            //Master left the lobby!
            if (Object.keys(lobbyLeaverObject).find(key => masterId)) { //check if masterId is in the leaver object
              //all connected non-master realize the master has left.

              //Use the first remaining person as the new master.
              //If that is me, set me to master and delete the old master
              const connectedKeys = Object.keys(newConnections) || [];
              if (connectedKeys.length && connectedKeys[0] === store.getState().battle.battlePlayerId[0]) {

                //console.log('I am the new master!');
                window.roomRef.child("masterCombatantId").set(store.getState().battle.battlePlayerId[0]);

                //Remove the old master:
                const lobbyMasterLeaverRef = window.roomRef.child('initialCombatantData').child(masterId);
                lobbyMasterLeaverRef.remove();

                //Also delete the old master's Buddies.
                Object.keys(store.getState().matchmaking.initialCombatantData).forEach(id => {
                  const model = store.getState().matchmaking.initialCombatantData[id];
                  if (model.isBuddy && model.belongsToClient === masterId) {
                    const lobbyLeaverBuddyRef = window.roomRef.child('initialCombatantData').child(id);
                    lobbyLeaverBuddyRef.remove();
                  }
                });



                //Set my local value as being the new master
                setBattleValue({
                  isMultiplayerMasterClient: true
                });
              }

            }
          }
        }
      }



      //If the battle has already started, watch for people leaving:
      if (store.getState().battle.hasBattleStarted) {

        // Don't mix this up with "lobby bots". This is only for in-battle people dropping out.
        //Connection count has gone down...
        if (Object.keys(newConnections).length < Object.keys(oldConnections).length) {

          //Diff here to figure out who left
          const newlyBotCombatants = getObjectKeyDiff(newConnections, oldConnections);
          //console.warn('non-master client(s) has left!', newlyBotCombatants);

          //If I'm the master, send notification that these combatants are now bots.
          if (store.getState().battle.isMultiplayerMasterClient) {
            //TODO: This is totally automatic right now. give a forgiving ms timeout chance for people to reconnect?
            //TODO: ^^ This could be wrapped in a timeout or something.

            sendNotificationOfBotCombatants( Object.keys(newlyBotCombatants) )
          }

          //if I'm NOT the master, and the master left. Ruh Roh.
          if (!store.getState().battle.isMultiplayerMasterClient) {
            if (Object.keys(newlyBotCombatants).find(key => masterId)) { //masterId is the playerId ID of the master
              //console.log('crap. the master left.'); //all connected clients do this.

              //Check if I am the first combatant in the updated keys after master left.
              const connectedKeys = Object.keys(newConnections) || []; //array of the connected keys
              if (connectedKeys.length && connectedKeys[0] === store.getState().battle.battlePlayerId[0]) {
                // console.log('I am the new master!');
                window.roomRef.child("masterCombatantId").set(store.getState().battle.battlePlayerId[0]);

                //Set my local value as being the new master
                setBattleValue({
                  isMultiplayerMasterClient: true
                });

                //I'm the new master now, so send out this notification of the old master being a bot now.
                sendNotificationOfBotCombatants(Object.keys(newlyBotCombatants));
              }
            }
          }
        }

        //Rejoining!
        //If connections have gone UP, see if this person is already listed as a Bot
        if (store.getState().battle.isMultiplayerMasterClient) { //Only master checks
          if (Object.keys(newConnections).length > Object.keys(oldConnections).length) {

            //Diff here to figure out who joined.
            const rejoiningCombatants = getObjectAdditions(newConnections, oldConnections);

            //Turn bots back to humans (local state)
            Object.keys(rejoiningCombatants).forEach(id => {
              setCombatantValue(id, {
                isBot: false
              })
            });

            //Turn rejoiner's Buddies to bots too.
            Object.keys(store.getState().battle.combatants).forEach(id => {
              const model = store.getState().battle.combatants[id];
              if (model.isBuddy) {
                //If I'm a buddy, see if my Client has rejoined
                if (Object.keys(rejoiningCombatants).includes(model.belongsToClient)) {
                  setCombatantValue(id, {
                    isBot: false
                  })
                }
              }
            });


            //Master updates server bot states
            sendNotificationOfBotCombatants([]); //Sort of hack. This fn looks at store.getState which we just set
          }
        }


      }
    });

    //Subscribe to changes on rollout.
    //Handle a new rollout when it comes in. This will send a "viewed" message after the client has seen the animations
    window.roomRef.child('rollout').on("value", function (snapshot) {
      //console.log('new rollout value', snapshot.val());
      const newRollout = snapshot.val();
      if (newRollout) {



        //Log this rollout if it's the first time we've seen it.
        if (!hasLoggedRolloutById(newRollout.rolloutId)) {
          // console.log('online play handling new Rollout', newRollout.rolloutId);
          handleNewRollout(newRollout);
        }


        //Master waits to hear that the last person has viewed the rollout.
        if (store.getState().battle.isMultiplayerMasterClient) {

          //Get the number of human players. We do not need to count "Viewed" notifications from Bots or Buddies.
          //(Buddies already 'view' by their belongsToClient person)
          const combatants = store.getState().battle.combatants;
          const humanPlayerCount = Object.keys(combatants).map(combatantId => {
            return combatants[combatantId]
          }).filter(combatantModel => {
            return !combatantModel.isBot && !combatantModel.isBuddy
          }).length;

          if (newRollout.seenBy && Object.keys(newRollout.seenBy).length === humanPlayerCount) {
            //We are ready to continue. Master figures out the next submitter and sends it to everybody.

            //Master destroy server rollout, then set next person to Selecting
            destroyServerRollout(function () {
              const nextBattleState = getUpdatedBattleState();
              sendBattleStateToServer(nextBattleState);
            });
          }
          //TODO: This test case may be causing the problems:
          if ((newRollout.seenBy && Object.keys(newRollout.seenBy).length > humanPlayerCount)) {
            console.warn('RUH ROH - more seen than human count');
            //NOTE: this log happened on a KICKED OUT person's console
          }
        }
      } else {
        if (newRollout === null) {
          //Master says the rollout should be cleared.
          setBattleValue({
            rolloutData: []
          })
        }
      }
    });


    //Subscribe to bots. New bot data coming in!
    window.roomRef.child('bots').on("value", function (snapshot) {

      const serverBots = snapshot.val();
      const serverBotIds = Object.keys(serverBots || {}); //empty object if no bots

      //Master has told us (and him/herself) that these people have left. So mark them as Bots
      serverBotIds.forEach(newBotCombId => {
        //Mark these leaver combatants as `isBot`
        setCombatantValue(newBotCombId, {
          isBot: true
        });

        //If I am the master, I may need to submit for this new Bot if he is the one that's up.
        //Otherwise we'd all be waiting for an offline person to submit something.
        if (store.getState().battle.isMultiplayerMasterClient) {
          //Find out who is supposed to submit right now. If it's the person who just left, submit for them.
          const combatantSelectingAction = getCombatantIdFromSelectingString(store.getState().battle.combatantSelectingAction);
          if (combatantSelectingAction === newBotCombId) {
            masterSelectsActionForBot(newBotCombId)
          }
        }
      });

      //Mark the NON-server bots as humans! - this will turn back the rejoining people that are no longer bots
      const combatants = store.getState().battle.combatants;
      Object.keys(combatants).forEach(key => {
        if (!serverBotIds.includes(key)) {
          //console.log('setting to human', combatants[key].name)
          setCombatantValue(key, {
            isBot: false //Turn back to human
          })
        }
      })

    });

    //Subscribe to battleState (which is all of our local combatants and stuff)
    window.roomRef.child('battleState').on("value", function (snapshot) {
      const battleState = snapshot.val();

      if (battleState) { //check that its not null.

        //Now check and apply explicit properties that we received

        //This is the `isBattleInit` notification
        if (battleState.isBattleInit) {
          //Set the combatants //We received combatants (I think just for initing, can't store model methods in Firebase)
          let combatantModels = {};
          Object.keys(battleState.combatants).forEach(key => {
            combatantModels[key] = new CombatantModel(battleState.combatants[key])
          });
          setBattleValue({
            combatants: combatantModels, //set the combatants
            teams: battleState.teams, //and the teams
          });

          //Master now starts the first series.
          if (store.getState().battle.isMultiplayerMasterClient) {

            //NEW: Master sets this specific battle-starting preset rollout
            sendPresetRolloutModelToServer({
              submitterCombatantId: "BATTLE-SYSTEM",
              rolloutId: "rollout_battle-starting",
              rolloutPayload: [
                {
                  type: "message",
                  content: [
                    'An enemy crew approaches for battle!' //TODO Not doing dynamic Online intros at the moment.
                                                           // Not sure what those should say
                  ]
                }
              ]
            })


          }
        }

        //Set seriesTurnOrder if we receive it
        if (battleState.seriesTurnOrder) {
          setBattleValue({
            seriesTurnOrder: battleState.seriesTurnOrder,
          });
        }
        //Set seriesTurnsSubmitters if we receive it
        if (battleState.seriesTurnsSubmitters) {
          //Convert back to empty array if the placeholder value "empty" is present
          //because Firebase eats empty arrays...
          setBattleValue({
            seriesTurnsSubmitters: battleState.seriesTurnsSubmitters === "empty" ? [] : battleState.seriesTurnsSubmitters
          })
        }



        //Set combatantSelectingAction if we receive it
        if (battleState.combatantSelectingAction) {

          const nextCombatantId = battleState.combatantSelectingAction;

          setBattleValue({
            combatantSelectingAction: nextCombatantId,
            arenaSubmissionMenuCombatantIdLock: nextCombatantId.match(/cloudQueueAction::/) ? null : nextCombatantId //This should never have "cloudQueueAction" in it, but if it does, it should be `null` here instead.
                                                                                    //See `start-turn-series` for ternary examples
          });

          //Master might need to auto submit for a bot or cloudQueue
          if (store.getState().battle.isMultiplayerMasterClient) {

            //Check if this is the battle "battle over" submission
            if (battleState.combatantSelectingAction === "battle-over") {
              // console.log('multiplayer battle over');

              submitBattleOver();
              return;
            }

            //Check if it's a cloud deal.
            if (battleState.combatantSelectingAction.match(/^cloudQueueAction/)) {
              masterSubmitsQueuedAction(battleState.combatantSelectingAction);
              return;
            }

            //Check if the newSelectingPerson is a bot. (//isBot check handled within that function.)
            masterSelectsActionForBot(
              getCombatantIdFromSelectingString(battleState.combatantSelectingAction)
            ); //ai handled deeper within this function

          }
        }

        //Receive a new cloudQueue, or a specific `false` value that specifies that new cloudQueue is empty. (Firebase eats empty things)
        if (battleState.cloudQueue || battleState.cloudQueue === false) {
          setBattleValue({
            cloudQueue: battleState.cloudQueue || [],
          });
        }


      }
    });


  });
}

// --------- SENDING as the Master //

/** Send new battleState to the clients (only master does this) */
export function sendBattleStateToServer(battleState) {

  //Make sure data is clean. Convert anything that needs to be converted.
  let cleanPayload = null;
  if (battleState.seriesTurnsSubmitters && battleState.seriesTurnsSubmitters.length === 0) {
    cleanPayload = {
      ...battleState,
      seriesTurnsSubmitters: "empty" //Transform empty array into "empty" placeholder string for Firebase
    };
  }

  window.roomRef.child('battleState').set(cleanPayload ? cleanPayload : battleState)
}

/** Clear out the rollout in multiplayer state (Only master does this) */
export function destroyServerRollout(callback = function () {
}) {
  window.roomRef.child('rollout').set(null).then(callback)
}

// /** Master notifies all clients that number of connections is correct and we're ready (Only master does this) */
// export function sendNotificationOfBattleStarting() {
//   //The battle state should be totally reset and clear.
//   //Time to notify people that the battle is starting!
//   window.roomRef.child('hasBattleStarted').set(true);
// }

/** Let clients know that these combatants {} are now BOTS. (Only master does this) */
export function sendNotificationOfBotCombatants(newlyBotCombatantIds = []) {

  const combatants = store.getState().battle.combatants;
  let bots = {};
  Object.keys(combatants).forEach(id => {

    const model = combatants[id];
    if (model.isBot || newlyBotCombatantIds.includes(id)) {
      bots[id] = {
        //This is a bot model.. saved in Firebase in the `bots` object
        name: model.name
      }
    }
    //Also make Buddies bots if their client is in the newlyBotCombatantIds list.
    if (model.isBuddy && newlyBotCombatantIds.includes(model.belongsToClient)) {
      bots[id] = {
        name: model.name //Same as above
      }
    }

  });

  window.roomRef.child('bots').set(bots);
  //server `bots` is now all bots that exist in the match, including both client Bots and lifetime Bots.
}







// ---------------- SENDING that EVERYBODY does (including Master) //

/** Tell the server that we have seen the rollout (ALL clients do this after completing their turn) */
export function sendRolloutStepsToServer(rollout, submitterCombatantId:string) {
  //In the future, the client can just send their SUBMISSION to a satellite node server that will run the probabilities and stuff.
  //This will help protect against cheating, because right now you could send up whatever you want.
  const now = Date.now();


  const rolloutUpdateModel = {
    submitterCombatantId: submitterCombatantId,
    rolloutId: makeId("rollout", 10) + `_${String(now)}`, //create an ID that can be used to track if client has seen this rollout before,
    timestamp: now,
    seenBy: [], //New rollout.. nobody has completed the viewing.
    submittedBy: store.getState().battle.battlePlayerId,
    rolloutPayload: rollout
  };
  window.roomRef.child('rollout').set(rolloutUpdateModel);
}

/* Give explicit rollout to server (for known events, like battle-end and battle-start) */
export function sendPresetRolloutModelToServer(rolloutModel) {
  window.roomRef.child('rollout').set({
    submittedBy: store.getState().battle.battlePlayerId,
    seenBy: [],
    timestamp: Date.now(),
    ...rolloutModel
      //includes `rolloutPayload`, and `rolloutId`
  });
}



/** Tell the server that we have seen the rollout (ALL clients do this) */
export function sendViewConfirmationToServer() {
  const clientId = store.getState().battle.battlePlayerId[0]; //This used to be just 1 string, but now it's an array. Send the first string for online mode.

  //window.roomRef.child('rollout').child("seenBy").push(clientId); //THIS IS THE OLD WAY

  //Try to manage duplicates by setting exact keys
  window.roomRef.child('rollout').child("seenBy").child(clientId).set(true);
  //Note: Only humans send this. Not bots.


  //If master, update the latest combatant state for rejoiners
  if (store.getState().battle.isMultiplayerMasterClient) {
    //Note: the only people who "request" this are people who are rejoining
    window.roomRef.child('rejoinCombatantState').update(
      getSafeCombatantsForFirebase(store.getState().battle.combatants)
    );
    window.roomRef.child('rejoinTeams').update(store.getState().battle.teams);
  }

}

//Strip functions from combatant models so we can store them in firebase
function getSafeCombatantsForFirebase(combatantModels={}) {
  let payload = {};
  Object.keys(combatantModels).forEach(combId => {

    const model = combatantModels[combId];
    let safeCombatant = {};
    Object.keys(model).forEach(key => {
      if (typeof model[key] !== "function") {
        safeCombatant[key] = model[key];
      }
    });
    payload[combId] = {...safeCombatant};
  });

  return payload;
}


// WEBPACK FOOTER //
// ./src/battle/connection/firebase.js